import { render, staticRenderFns } from "./pieceInfo.vue?vue&type=template&id=2b00053a&scoped=true"
import script from "./pieceInfo.vue?vue&type=script&lang=js"
export * from "./pieceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00053a",
  null
  
)

export default component.exports